<template>
  <div class="hello">
    <!-- <Header></Header> -->
    <div :class="isShowFoot==false?'conter conter2':'conter'" id="content">
      <router-view></router-view>
    </div>
    <Footer v-if="isShowFoot"></Footer>
  </div>
</template>

<script>
// import Header from "./header.vue";
import Footer from "./footer.vue";
export default {
  components: {
    // Header,
    Footer,
  },
  data() {
    return {
      isShowFoot: true,
    };
  },
  watch: {
    $route() {
      // this.getRoute();
    },
  },
  mounted() {
    // this.getRoute();
  },
  methods: {
    // getRoute() {
    //   // this.clickLi=x.path
    //   let pathName = this.$route.path;
    //   if (pathName.indexOf("details") >= 0) {
    //     this.isShowFoot = false;
    //   }
    // },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  margin: auto;
}
.conter {
  height: calc(100vh - 49px);
  /* border: 1px solid; */
  overflow: scroll;
}
.conter2{
height: calc(100vh - 49px);
}
</style>
